(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    $(document).on('click', '.add-to-cart-ajax', function(e) {
  e.preventDefault();
  var variantId = $(this).data('variant-id');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { id: variantId, quantity: 1 },
    dataType: 'json',
    success: function(item) {
      // Получаем мини-корзину через view=mini
      $.get('/cart?view=mini', function(data) {
        var $temp = $('<div>').html(data);
        var $miniContent = $temp.find('.minicart-inner').html();

        // Обновляем все мини-корзины
        $(".minicart-inner").each(function() {
          $(this).html($miniContent);
          $(this).removeClass('show');
          void this.offsetWidth;
          $(this).addClass('show');
        });

        // Обновляем все счетчики
        var cartItemCount = $temp.find('.bigcounter').first().text();
        $(".bigcounter").text(cartItemCount);

        $("body").addClass('fix');

        $(".offcanvas-close, .minicart-close, .offcanvas-overlay").off('click').on('click', function(){
          $("body").removeClass('fix');
          $(".minicart-inner").removeClass('show');
        });
      });
    },
    error: function(xhr, status, error) {
      console.error('Cart add error:', error);
      alert('Failed to add the product to the cart.');
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
